import plugin from 'tailwindcss/plugin';

const masonry = plugin.withOptions(function () {
	return function ({ addComponents, e, theme }) {
		addComponents({
			[`.${e('masonry-gap')}`]: {
				gap: `var(--masonry-gap, ${theme('spacing.2')})`,
			},
		});
	};
});

export default masonry;
